<template>
  <div class="form-group text-start" id="password_input">
    <div class="d-flex justify-content-between">
      <label v-if="label" class="form-label text-muted">
        {{ label }} <i v-if="required" class="text-danger">*</i>
      </label>
      <slot name="labelContentEnd"></slot>
    </div>
    <!-- <label class="form-label text-dark text-label"> {{ label }} </label> -->

    <div class="input-group input-group-merge">
      <input v-model="model.$model" :maxlength="30" :class="{ 'is-invalid': model.$error }"
        class="form-control border-right-0" :placeholder="placeholder" :type="passwordFieldType" />
      <span class="input-group-text cursor-pointer" :class="{ 'border-danger': model.$error }">
        <i @click="togglePassword()" class="fas text-muted" :class="{
        'fa-eye': passwordFieldType == 'text',
        'fa-eye-slash': passwordFieldType == 'password',
      }"></i>
      </span>
      <div class="invalid-feedback">
        <small>{{ errorMsg }}</small>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

withDefaults(
  defineProps<{
    model?: any;
    label?: string;
    placeholder?: string;
    errorMsg?: string;
    required?: boolean;
  }>(),
  {
    model: () => ({}),
    label: "Password",
    placeholder: "Enter your password",
    errorMsg: "Por favor, preencha este campo corretamente",
    required: false,
  },
);

const passwordFieldType = ref("password");

const togglePassword = () => {
  passwordFieldType.value =
    passwordFieldType.value == "password" ? "text" : "password";
};
</script>
